import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { PartnerName } from '../types/entities/PartnerName';
import { salesPartner } from './salesPartner';
import { activity } from './activity';

export const partnerName: SchemaWithClient<PartnerName> = {
  name: 'Partner Names',
  pluralName: 'Partner Names',

  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    sales_partner: {
      name: 'Sales Partner',
      fieldRenderer: SelectField.tableAdapter(salesPartner),
      url: salesPartner.client.getAllPath,
      tempSchema: salesPartner,
      switchboard: true,
    },
    activity: {
      name: 'Activity',
      fieldRenderer: SelectField.tableAdapter(activity),
      url: activity.client.getAllPath,
      tempSchema: activity,
      switchboard: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/partner-names'),
};
